import React, { useState, useEffect } from "react";
import { useAuth } from "./items/AuthProvider";
import request from "../services/Request";
import HorizontalCard from "./Cards/HorizontalCard";
import SearchComponent from "./Cards/SearchComponent";
import { FavoriteBorder, Favorite } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { formatAddress } from "../services/method/methods";

const Locations = () => {
  const history = useNavigate();
  const { user, setLoading } = useAuth();
  const [machines, setMachines] = useState([]);
  const [filteredMachines, setFilteredMachines] = useState([]);
  const [favoriteMachines, setFavoriteMachines] = useState([]);

  useEffect(() => {
    setLoading(true);
    request({
      method: "post",
      url: "/getMachinesClientUser",
      data: {
        referTo: user.referTo,
        _id: user._id,
      },
    })
      .then((res) => {
        console.log("res.data");
        const favos = res.data?.favo;
        const result = res.data?.foundMachines?.map((item) => {
          if (item.active) {
            const diff = new Date().getTime() - new Date(item.active);
            if (diff <= 90000) {
              item.online = true;
            }
          }

          if (favos?.length > 0) {
            if (favos?.includes(item._id)) {
              item.isFavorite = true;
            }
          }

          item.addresssString = item?.address?.full_address;
          if (item?.address?.street) {
            item.addresssString = formatAddress(item?.address);
          }

          return {
            id: item._id, // Assuming each machine has a unique _id from the backend
            imageUrl: "/img/image.png",
            title: item.description,
            location: item.addresssString,
            isActive: item.online,
            isFavorite: item.isFavorite,
          };
        });

        console.log("favos", favos);

        setMachines(result);
        setFilteredMachines(result);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSearch = (searchTerm) => {
    const filtered = machines.filter((machine) => {
      return (
        machine?.title?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
        machine?.location?.toLowerCase()?.includes(searchTerm.toLowerCase())
      );
    });
    setFilteredMachines(filtered);
  };

  const toggleFavorite = (machineId) => {
    const updatedMachines = machines.map((machine) => {
      if (machine.id === machineId) {
        return { ...machine, isFavorite: !machine.isFavorite };
      }
      return machine;
    });

    setMachines(updatedMachines);

    // Update filtered machines as well
    const updatedFiltered = filteredMachines.map((machine) => {
      if (machine.id === machineId) {
        return { ...machine, isFavorite: !machine.isFavorite };
      }
      return machine;
    });

    setFilteredMachines(updatedFiltered);

    //get all favorite machines
    let favoriteMachines = updatedMachines.filter(
      (machine) => machine.isFavorite
    );

    favoriteMachines = favoriteMachines.map((machine) => machine.id);

    console.log("favoriteMachines", favoriteMachines);

    //send request to backend
    request({
      method: "post",
      url: "/clientUser/setFavoriteMachine",
      data: {
        favoriteMachines: favoriteMachines,
        _id: user._id,
      },
    })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  const sortedMachines = [...filteredMachines].sort((a, b) => {
    if (a.isFavorite && !b.isFavorite) return -1;
    if (!a.isFavorite && b.isFavorite) return 1;
    return 0;
  });

  const handleClick = (machine) => {
    console.log("machine", machine);
    localStorage.setItem("machineID", machine.id);
    history(`/machineUI/home`);
  };

  return (
    <div className="page-container">
      <div className="mb-4">
        <SearchComponent onSearch={handleSearch} />
      </div>
      <div>
        {sortedMachines.map((machine) => (
          <HorizontalCard
            onClick={() => handleClick(machine)}
            key={machine.id}
            imageUrl={machine.imageUrl}
            title={machine.title}
            location={machine.location}
            className="mb-4"
            isActive={machine.isActive}
            isFavorite={machine.isFavorite}
            onFavoriteToggle={() => toggleFavorite(machine.id)}
            favoriteIcon={
              machine.isFavorite ? (
                <Favorite className="text-red-500" />
              ) : (
                <FavoriteBorder className="text-gray-400" />
              )
            }
          />
        ))}
      </div>
    </div>
  );
};

export default Locations;
